import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cn from 'classnames';
import subscriptionDecorator from 'subscriptions/decorator';
import SprintSwitcherList from './SwitcherList/sprint';
import BypassedSwitcherList from './SwitcherList/bypassed';
import QuickSwitcherList from './SwitcherList/quick';
import { getUser } from 'reducers';
import { getCarrier } from '../../helpers/subs';
import styles from './index.module.css';
import toggle from './toggle.svg';

class SubscriptionSwitcher extends Component { 
  state = {
    open: false
  }
  
  toggleDropdown = () => {
    this.state.open ? this.setState({ open: false }) : this.setState({ open: true });
  }

  render() {
    const { userId, quickRoute, bypassedRoute, sprintRoute, subscription } = this.props

    if (!userId || !subscription) { return null; }

    const carrier = getCarrier(subscription);
    const isSuspended = subscription[`${carrier}_status`] === 'suspended';

    return (
      <div className={styles.SubscriptionSwitcher}>
        <div className={styles.active} onClick={this.toggleDropdown}>
          <div className={styles.avi}>
            {subscription.first_name[0]}
            {subscription.last_name[0]}
          </div>
          {subscription.first_name} {subscription.last_name}
          {isSuspended && (
            <span className={styles.suspended}>Service suspended</span>
          )}
          <div className={cn(styles.toggle, this.state.open && styles.open)}>
            <img src={toggle} />
          </div>
        </div>
        {this.state.open &&
          <div className={styles.subList} onClick={this.toggleDropdown}>
            <SprintSwitcherList userId={userId} route={sprintRoute} active={subscription} />
            <BypassedSwitcherList userId={userId} route={bypassedRoute} active={subscription} />
            <QuickSwitcherList userId={userId} route={quickRoute} active={subscription} />
          </div>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  userId: getUser(state) && getUser(state).id
});

export default compose(
  subscriptionDecorator,
  connect(
    mapStateToProps,
    null
  )
)(SubscriptionSwitcher);
